import { getRoot } from "mobx-state-tree"

export const effectsFactoryViews = self => ({

})